import { takeLatest, put } from 'redux-saga/effects';
import {
  loaderAction,
  loadingIndicatorAction,
  roleModeAction,
  staffSettingsAction, savePermissionsAction, saveStaffPermissions, loginUser, saveAuthTransactions,
  saveUpdateAuthBatchEndDate,
  saveUpdateServiceBatchEndDate,
  saveAuthServiceReviewsRequestAction,
  getAuthServiceReviewsRequestAction
} from '../actions';
import * as TYPES from '../actions/types';
import DEVELOPMENT_CONFIG from "../../helper/config";
import moment from 'moment';
import { PermissionHelper } from '../../helper/permission-helper';
import { Encrption } from '../../app-modules/encrption';
import { UserAuthResponse } from '../../dataModels/authDataModels';
import { getUser } from '../../services/authService';
import { UserPermissions } from '../../dataModels/userPermissionModels';
import { SettingsResponse } from '../../dataModels/userSettingsModel';
import { NotificationManager } from "react-notifications";
import { customAxios } from 'src/services/useExPressApi';
import { API_ENDPOINTS } from 'src/services/api-endpoints';
import { CLIENT_TYPES } from '../actions/types_clients';



export function* LoginSaga() {
  yield takeLatest(TYPES.LOGIN_ACTION, loginWorker);
}


function* loginWorker(param: any) {
  // const navigate = useNavigate();
  try {
    // yield put(loaderAction(true));
    yield put(loadingIndicatorAction(true));
    const response: UserAuthResponse = yield getUser.auth(param['payload']);
    // yield put(loaderAction(false));
    yield put(loadingIndicatorAction(false));
   

    yield put(loginUser(response.resultData));
  } catch (err) {
  }
}

export function* getRoleSaga() {
  yield takeLatest(TYPES.ROLE_MODE, getRoleModulesWorker);
}

function* getRoleModulesWorker(param: any) {
  let response: UserPermissions = yield getUser.getUserPermissions()
  let list = response?.resultData;
  if (list.length > 0) {
    let data = yield PermissionHelper(response?.resultData);
    yield put(savePermissionsAction(data));
  }
}


export function* getStaffSettingsSaga() {
  yield takeLatest(TYPES.STAFF_SETTINGS, getStaffSettingListWorker);
}


function* getStaffSettingListWorker(param: any) {
  let id = Encrption(param['payload']);

  let response: SettingsResponse = yield getUser.getStaffSettings(id);
  yield put(saveStaffPermissions(response?.resultData));
}

export function* getAuthViewTransSaga() {
  yield takeLatest(TYPES.GET_AUTH_TRANSACTIONS, getAuthViewTransWorker);
}

function* getAuthViewTransWorker(param: any) {
  yield put(loaderAction(true));
  let response: any = yield getUser.getAuthTransaction(param['payload']);
  yield put(loaderAction(false));
  yield put(saveAuthTransactions(response?.resultData));
}

export function* updateAuthBatchEndDateSaga() {
  yield takeLatest(TYPES.UPDATE_AUTH_BATCH_END_DATE, updateAuthBatchEndDateWorker);
}

function* updateAuthBatchEndDateWorker(param: any) {
  yield put(loaderAction(true));
  let response: any = yield getUser.updateAuthBatchEndDate(param['payload']);
  if(response) {
    yield put(saveUpdateAuthBatchEndDate(response.resultData))
    if(Object.keys(response.resultData).length <= 0) {
      NotificationManager.success('Success')
    }
  }
  yield put(loaderAction(false));
}

export function* updateServiceBatchEndDateSaga() {
  yield takeLatest(TYPES.UPDATE_SERVICE_BATCH_END_DATE, updateServiceBatchEndDateWorker);
}

function* updateServiceBatchEndDateWorker(param: any) {
  yield put(loaderAction(true));
  let response: any = yield getUser.updateServiceBatchEndDate(param['payload']);
  if(response) {
    yield put(saveUpdateServiceBatchEndDate(response.resultData))
    if(Object.keys(response.resultData).length <= 0) {
      NotificationManager.success('Success')
    }
  }
  yield put(loaderAction(false));
}

export function* insertAuthServiceReviewsRequestSaga() {
  yield takeLatest(TYPES.INSERT_AUTH_SERVICE_REVIEWS_REQUEST, insertAuthServiceReviewsRequestWorker);
}

function* insertAuthServiceReviewsRequestWorker(param: any) {
  yield put(loaderAction(true));
  const response = yield customAxios.post(`${API_ENDPOINTS.INSERT_AUTH_SERVICE_REVIEWS_REQUEST}`, param['payload']);
  
  if(response?.statusCode === 200) {
    NotificationManager.success('Auth Service Reviews Request inserted successfully')
    yield put(getAuthServiceReviewsRequestAction(param['payload']));
  }
  yield put(loaderAction(false));
}

export function* getAuthServiceReviewsRequestSaga() {
  yield takeLatest(CLIENT_TYPES.GET_AUTH_SERVICE_REVIEWS_REQUEST, getAuthServiceReviewsRequestWorker);
}

function* getAuthServiceReviewsRequestWorker(param: any) {
  yield put(loaderAction(true));
  const response = yield customAxios.get(`${API_ENDPOINTS.GET_AUTH_SERVICE_REVIEWS_REQUEST}?clientId=${param['payload']?.clientId}`);
  
  if(response?.statusCode === 200) {
    yield put(saveAuthServiceReviewsRequestAction(response));
  }
  yield put(loaderAction(false));
}